import mitt from 'mitt';
import { ENV_CONFIG } from '@laigu/constants';
import handleSocket from './handle-socket';
import eventOn from './event-on';
import { isPerspectiveMode } from '@/utils';

const connectSocket = ({ emitter, socketUrl, token, entId, agentId }) => {
  const browserId = new Date() * 1;
  // eslint-disable-next-line max-len
  const setSocketUrl = `${socketUrl}?token=${token}&utype=agent&ent_id=${entId}&id=${agentId}&browser_id=${browserId}`;

  return handleSocket(emitter, setSocketUrl, agentId, entId);
};
const defaultSocketUrl = ENV_CONFIG.MQ_SOCKET_URL || 'https://eco-push-api-agent.laigu.com/push';

const init = ({ entId, agentId, token, socketUrl }) => {
  const emitter = mitt();
  const socketConnectInstance = isPerspectiveMode()
    ? null
    : connectSocket({
        emitter,
        socketUrl: socketUrl || defaultSocketUrl,
        token,
        entId,
        agentId
      });
  // 设置请求默认值

  emitter.promiseEmit = (type, payload) => {
    return new Promise((resolve, reject) => {
      emitter.emit(type, {
        payload,
        success: res => {
          resolve(res);
        },
        error: res => {
          reject(res);
        }
      });
    });
  };

  emitter.promiseOn = (type, func) => {
    emitter.on(type, async ({ success, error, payload }) => {
      try {
        if (func) {
          const data = await func(payload);
          success(data);
        }
      } catch (e) {
        error(e);
      }
    });
  };

  eventOn(emitter, socketConnectInstance);

  return emitter;
};

export default init;
